import { render, staticRenderFns } from "./entity-documents.vue?vue&type=template&id=8dea8ff6"
import script from "./entity-documents.vue?vue&type=script&lang=js"
export * from "./entity-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports